<template>
  <ContainerProduction
    v-bind="containerProps"
    :style-overrides="tappableStyleOverrides"
    @click="handleClick"
  >
    <slot />
  </ContainerProduction>
</template>

<script>
import ContainerProduction from "%/dynamic-component-editor/standard-elements/layouts/ContainerProduction.vue";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import ActionTrigger from "%/dynamic-component-editor/options/action-trigger";
import resolveVisibleOption from "%/dynamic-component-editor/helpers/resolve-visible-option";
import Visible from "%/dynamic-component-editor/options/visible";
import { isVisibleOnWeb } from "%/dynamic-component-editor/helpers/visibility-surface";

export default {
  name: "EntityActionContainer",
  components: { ContainerProduction },
  production: true,
  mixins: [DynamicElementMixin, DynamicElementWithContext],
  inheritAttrs: false,
  computed: {
    containerProps() {
      return {
        ...this.$attrs,
        optionValues: this.optionValues,
        activeState: this.activeState,
        identifier: this.identifier,
        themeMode: this.themeMode,
        editMode: this.editMode,
      };
    },
    firesWhenShown() {
      return this.getOptionValue(ActionTrigger) === ActionTrigger.WHEN_SHOWN;
    },
    isShownToFire() {
      return !this.editMode && this.firesWhenShown
        && isVisibleOnWeb(resolveVisibleOption(this.getOptionValue(Visible), this));
    },
    tappableStyleOverrides() {
      if (this.editMode || this.firesWhenShown || !this.elementContext?.actionName) {
        return {};
      }
      return { cursor: "pointer" };
    },
  },
  watch: {
    isShownToFire: {
      immediate: true,
      handler(shown) {
        if (shown) {
          this.triggerNamedAction(this.elementContext?.actionName);
        }
      },
    },
  },
  methods: {
    handleClick(event) {
      if (!this.firesWhenShown) {
        this.executeAction(event);
      }
    },
  },
};
</script>
